export default __webpack_public_path__ + "static/media/back-top.0c54eb64.svg";